import React, { useEffect, useState, FC } from 'react';
import classnames from 'classnames';

import { InputMask, defaultStrings } from '@glu/input-mask-react';
import gluLocale from '@glu/locale';

import { formatCurrencyForInput } from 'utils/currency';

import useStyles from './CurrencyInput.styles';

interface Props {
  prefixSymbol: string;
  decimalPlaces: number;
  symbol: string;
  value: string | number;
  className: string;
  hidePrefixSymbol?: boolean;
  [key: string]: unknown;
}

const CurrencyInput: FC<Props> = ({
  className,
  decimalPlaces = 2,
  hidePrefixSymbol = false,
  prefixSymbol = '$',
  symbol = '.',
  ...props
}) => {
  const [cursorPosition, setCursorPosition] = useState(0);
  const [element, setElement] = useState(null);
  const [previousFormattedValue, setPreviousFormattedValue] = useState<string | undefined>();
  const { input } = useStyles();

  gluLocale.set({
    ...defaultStrings
  });

  // Maintains cursor position while formatting
  const format = (value = '') => {
    const formattedValue = formatCurrencyForInput({ decimalPlaces, symbol })(value);
    if (element && formattedValue !== previousFormattedValue) {
      const newLength = formattedValue.length;
      const lengthDiff = newLength - value.length;
      const pos = element?.selectionEnd;
      const newPos = pos + lengthDiff;
      setCursorPosition(newPos);
    }
    setPreviousFormattedValue(formattedValue);
    return formattedValue;
  };

  const handleKeyDown = (event) => {
    setElement(event.target);
  };

  useEffect(() => {
    element?.setSelectionRange(cursorPosition, cursorPosition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cursorPosition]);

  return (
    <InputMask
      className={classnames(input, className)}
      format={format}
      formatValueFromProps
      onKeyPress={handleKeyDown}
      {...(hidePrefixSymbol ? {} : { prefixSymbol })}
      {...props}
    />
  );
};

export default CurrencyInput;
